let lenis = null;
let lockCount = 0;
export const setLenis = (l) => {
  lenis = l;
};
export const getLenis = () => lenis;
export const stopLenis = () => {
  lockCount += 1;
  lenis?.stop();
  document.body.style.overflow = "hidden";
};
export const startLenis = () => {
  if (lockCount === 0 && process.env.NODE_ENV !== "production") {
    console.warn("startLenis called without a matching stopLenis");
  }
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    lenis?.start();
    document.body.style.overflow = "";
  }
};
